<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <MiniActasReunionFormulario
            v-auth-acl="'gh-act-act_seg-insert'"
            :idreferencia="idreferencia"
            :referencia="referencia"
            @open="open"
            @close="close"
          ></MiniActasReunionFormulario>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'MiniActasReunion',
  components: {
    MiniActasReunionFormulario: () => import('../components/MiniActasReunionFormulario')
  },
  props: {
    idreferencia: {
      type: String,
      default: ''
    },
    referencia: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    page: {
      title: 'Actas'
    },
    breadcrumbs: [
      {
        text: 'Actas',
        disabled: true
      },
      {
        text: 'Acta de Seguimiento',
        disabled: false
      }
    ]
  }),
  methods: {
    open() {},
    close() {}
  }
};
</script>
